import EAFieldset from "../../../components/EAFieldset";
import EAButtonBar from "../../../components/EAButtonBar";
import EAButton from "../../../components/EAButton";
import React from "react";
import {useForm} from "../../../utils/FormUtils";
import {useHttp} from "../../../services/HttpService";
import {getAllBescheidArtEndpointEndpoint, getBescheidQualitaetEndpoint} from "../../../services/WertelistenService";

export default function BescheidUebersichtSuche(props) {
    const [bescheidQualitaetOptionen] = useHttp(getBescheidQualitaetEndpoint);
    const [bescheidArtOptionen] = useHttp(getAllBescheidArtEndpointEndpoint);
    const {values, setValues, formFactory} = useForm({});

    const resetSuche = () => setValues({});
    const startSuche = () => {
        const queryObject = buildQueryObject(values);
        props.onStartSuche(queryObject);
    };

    const buildQueryObject = (item) => {
        const queryObject = {};
        if (item.bescheidQualitaet) {
            queryObject.bescheidQualitaetId = values.bescheidQualitaet.id;
        }

        if (item.bescheidArt) {
            queryObject.bescheidArtId = values.bescheidArt.id;
        }

        if (item.bescheidDatumVon) {
            queryObject.bescheidDatumVon = buildDateStr(values.bescheidDatumVon);
        }

        if (item.bescheidDatumBis) {
            queryObject.bescheidDatumBis = buildDateStr(values.bescheidDatumBis);
        }

        return queryObject;
    };

    const buildDateStr = (date) => {
        const fullYear = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0")
        const day = date.getDate().toString().padStart(2, "0");

        return "" + fullYear + month + day;
    }

    return (
        <EAFieldset caption={"Suche"}>
            <div className="gridl" style={{gridTemplateColumns: "1fr 1fr 12em 12em"}}>
                {formFactory.renderAutocomplete(
                    "bescheidQualitaet",
                    "bescheidQualitaet",
                    "Bescheidqualität",
                    bescheidQualitaetOptionen.data,
                    "value",
                    "id",
                    bescheidQualitaetOptionen.loading
                )}
                {formFactory.renderAutocomplete(
                    "bescheidArt",
                    "bescheidArt",
                    "Bescheidart",
                    bescheidArtOptionen.data,
                    "value",
                    "id",
                    bescheidArtOptionen.loading
                )}
                {formFactory.renderDatePicker(
                    "bescheidDatumVon",
                    "bescheidDatumVon",
                    "Bescheiddatum von")}
                {formFactory.renderDatePicker(
                    "bescheidDatumBis",
                    "bescheidDatumBis",
                    "Bescheiddatum bis")}
            </div>
            <EAButtonBar style={{marginTop: "var(--buttonBar-spacing-top)"}}>
                <EAButton
                    id={"bescheid-suche-reset"}
                    label="Zurücksetzen"
                    onClick={resetSuche}
                />
                <EAButton
                    id={"bescheid-suche-submit"}
                    label="Suchen"
                    onClick={startSuche}
                    color="primary"/>
            </EAButtonBar>
        </EAFieldset>
    );
}
